import { useQuery } from "@tanstack/react-query";
import useApiHelper from "../hooks/useApiHelper";
import { PartLabelDisplay } from "../models/LabelDisplay";
import { DefaultResponseWithData } from "../models/system";

// Every per-category key sits under this prefix so the Part Tag editor can invalidate them all.
export const partLabelDisplayQueryKeyPrefix = ["label", "display"] as const;

export const partLabelDisplayQueryKey = (categoryId?: string | null) =>
  [...partLabelDisplayQueryKeyPrefix, categoryId ?? "default"] as const;

// The API resolves the part tag assigned to the category, falling back to the Default tag.
export const partLabelDisplayUrl = (categoryId?: string | null) =>
  categoryId ? `/template/label/display?categoryId=${categoryId}` : `/template/label/display`;

export const partLabelDisplayStaleTimeMs = 1000 * 60 * 60; // 1 hour

export default function usePartLabels(categoryId?: string | null) {
  const { get } = useApiHelper();

  const labelDisplay = useQuery(
    partLabelDisplayQueryKey(categoryId),
    () => get<DefaultResponseWithData<PartLabelDisplay>>(partLabelDisplayUrl(categoryId)),
    { staleTime: partLabelDisplayStaleTimeMs }
  );

  return { labelDisplay };
}
